"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.App = undefined;

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

require("../../styles/styles.scss");

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require("react-redux");

var _reactHelmet = require("react-helmet");

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _browserCookies = require("browser-cookies");

var _browserCookies2 = _interopRequireDefault(_browserCookies);

var _config = require("../../config");

var _config2 = _interopRequireDefault(_config);

var _reduxConnect = require("redux-connect");

var _reactRouterRedux = require("react-router-redux");

var _menu = require("../../redux/modules/menu");

var _Menu = require("../../components/menu/Menu");

var _Menu2 = _interopRequireDefault(_Menu);

var _auth = require("../../redux/modules/auth");

var _ads = require("../../redux/modules/ads");

var _company = require("../../redux/modules/company");

var _Header = require("../../components/Header");

var _Header2 = _interopRequireDefault(_Header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var App = exports.App = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref, [this].concat(args))), _this), _this.register = function () {
      _this.props.pushRoute("/rekisteroidy");
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _props = this.props,
          auth = _props.auth,
          pushRoute = _props.pushRoute,
          ads = _props.ads,
          loadAds = _props.loadAds,
          loadUser = _props.loadUser,
          license = _props.license;


      if (!auth.user && nextProps.auth.user) {
        loadAds();
        this.loadCompany(nextProps.auth);
        pushRoute("/");
      }

      if (!ads.createAdSuccess && nextProps.ads.createAdSuccess) {
        loadAds();
      }

      if (!license.orderLicenseSuccess && nextProps.license.orderLicenseSuccess) {
        loadUser();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var auth = this.props.auth;

      if (_browserCookies2.default.get(_config2.default.tokenCookie) && auth.error) {
        _browserCookies2.default.erase(_config2.default.tokenCookie);
      }
      this.loadCompany(auth);
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          toggleMenu = _props2.toggleMenu,
          logout = _props2.logout,
          auth = _props2.auth,
          location = _props2.location;


      if (location.pathname.includes("/tulosta")) {
        return _react2.default.createElement(
          "div",
          { className: "print" },
          this.props.children
        );
      }

      return _react2.default.createElement(
        "div",
        { className: "app-container" },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          "div",
          { className: "app-content" },
          _react2.default.createElement(_Header2.default, {
            toggle: toggleMenu,
            logout: logout,
            register: this.register,
            user: auth.user
          }),
          _react2.default.createElement(
            "div",
            { className: "full-container" },
            _react2.default.createElement(
              "div",
              { className: "menu-desktop" },
              this.renderMenu("desktop")
            ),
            _react2.default.createElement(
              "main",
              { className: "main-col" },
              location.pathname === "/" ? _react2.default.createElement(
                "div",
                { className: "expand" },
                this.props.children
              ) : _react2.default.createElement(
                "div",
                { className: "content-container" },
                _react2.default.createElement(
                  "div",
                  { className: "container" },
                  _react2.default.createElement(
                    "div",
                    { className: "row" },
                    this.props.children
                  )
                )
              )
            )
          )
        ),
        this.renderMenu("mobile")
      );
    }
  }, {
    key: "loadCompany",
    value: function loadCompany(auth) {
      var loadCompany = this.props.loadCompany;

      if (!(0, _company.isLoaded)() && auth.user && auth.user.company_id) {
        loadCompany();
      }
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(type) {
      var _props3 = this.props,
          menuOpen = _props3.menuOpen,
          toggleMenu = _props3.toggleMenu,
          auth = _props3.auth,
          logout = _props3.logout,
          company = _props3.company;

      return _react2.default.createElement(_Menu2.default, {
        type: type,
        open: menuOpen,
        toggle: toggleMenu,
        user: auth.user,
        company: company.company,
        logout: logout
      });
    }
  }]);
  return App;
}(_react.Component), _class.propTypes = {
  children: _react.PropTypes.object.isRequired,
  auth: _react.PropTypes.object.isRequired,
  license: _react.PropTypes.object.isRequired,
  company: _react.PropTypes.object.isRequired,
  logout: _react.PropTypes.func.isRequired,
  pushRoute: _react.PropTypes.func.isRequired,
  menuOpen: _react.PropTypes.bool.isRequired,
  toggleMenu: _react.PropTypes.func.isRequired,
  ads: _react.PropTypes.object,
  location: _react.PropTypes.object.isRequired,
  loadAds: _react.PropTypes.func.isRequired,
  loadUser: _react.PropTypes.func.isRequired,
  loadCompany: _react.PropTypes.func.isRequired
}, _temp2);
exports.default = (0, _reduxConnect.asyncConnect)([{
  promise: function promise(_ref2) {
    var _ref2$store = _ref2.store,
        dispatch = _ref2$store.dispatch,
        getState = _ref2$store.getState;

    var promises = [];

    if (!(0, _auth.isLoaded)(getState())) {
      promises.push(dispatch((0, _auth.load)()));
    }

    return _promise2.default.all(promises);
  }
}, {
  promise: function promise(_ref3) {
    var _ref3$store = _ref3.store,
        dispatch = _ref3$store.dispatch,
        getState = _ref3$store.getState;

    var promises = [];

    if (!(0, _ads.isSoilTypesLoaded)(getState())) {
      promises.push(dispatch((0, _ads.loadSoilTypes)()));
    }

    return _promise2.default.all(promises);
  }
}])((0, _reactRedux.connect)(function (state) {
  return {
    auth: state.auth,
    menuOpen: state.menu.open,
    ads: state.ads,
    license: state.license,
    company: state.company
  };
}, {
  logout: _auth.logout,
  pushRoute: _reactRouterRedux.push,
  toggleMenu: _menu.toggleMenu,
  loadAds: _ads.loadAds,
  loadUser: _auth.load,
  loadCompany: _company.load,
  isCompanyLoaded: _company.isLoaded
})(App));


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/App/App.js
 ** module id = 1207
 ** module chunks = 0
 **/